<!-- akce řádku jako v AISK: textové tlačítko ⋮ -->
<button
  pButton
  type="button"
  aria-label="Akce"
  aria-haspopup="menu"
  (click)="toggle(menu, $event)"
  class="p-button-text">
  <i class="pi pi-ellipsis-v" pButtonIcon aria-hidden="true"></i>
</button>

<p-tieredmenu #menu [model]="model()" [popup]="true" appendTo="body" [styleClass]="menuStyleClass()"> </p-tieredmenu>
